<template>
	<div id="wrap">
		<div class="flex flex-justify flex-wrap">
			<div>
				<el-button
					v-for="list in yearList"
					:key="list"
					:type="buttonType(list)"
					@click="step(list)"
					>{{ list }}</el-button
				>
			</div>
			<div>
				<el-button type="primary" @click="downloads"> 一键生成并下载</el-button>
			</div>
		</div>
		<p class="txt">上传文件格式:pdf/图片/xls/xlsx/doc/docx</p>
		<el-table
			class="table"
			:data="tableData"
			:header-cell-style="{ background: '#F5F7FA' }"
			v-loading="loading"
			:row-class-name="tableRowClassName"
		>
			<el-table-column label="材料名称" prop="fileType">
				<template slot-scope="scope">
					{{ fileType[scope.row.fileType - 1] }}
				</template>
			</el-table-column>
			<el-table-column prop="fileTime" label="日期"> </el-table-column>
			<el-table-column
				prop="fileRemark"
				label="备注"
				show-overflow-tooltip
			></el-table-column>

			<el-table-column label="操作" width="100" fixed="right">
				<template slot-scope="scope">
					<el-button
						v-if="scope.row.fileType == 3 || scope.row.fileType == 4"
						@click="sc(scope.row.fileType)"
						type="text"
						size="small"
						class="green"
						>生成</el-button
					>
					<el-upload
						class="upload-demo"
						ref="upload"
						:action="upload.url"
						:disabled="upload.isUploading"
						:data="{
							annual: queryParams.annual,
							projectId: queryParams.projectId,
							fileType: scope.row.fileType
						}"
						:show-file-list="false"
						:before-upload="beforeUpload"
						:on-success="handleFileSuccess"
						:on-error="handleFileError"
						:on-exceed="Exceed"
					>
						<el-button
							v-if="
								scope.row.fileType == 1 ||
									scope.row.fileType == 2 ||
									scope.row.fileType == 5 ||
									scope.row.fileType == 6 ||
									scope.row.fileType == 7 ||
									scope.row.fileType == 8
							"
							type="text"
							size="small"
							class="green"
							>上传</el-button
						>
					</el-upload>
					<el-button
						type="text"
						size="small"
						v-if="scope.row.fileUrl != null"
						@click="xz(scope.row.fileUrl)"
						class="red"
						>下载</el-button
					>
					<el-button
						type="text"
						size="small"
						v-if="scope.row.fileUrl == null"
						disabled
						>下载</el-button
					>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import {
	exportsQueryAdditionalDeductionReferenceMaterialsAnnual,
	exportsQueryAdditionalDeductionReferenceMaterials,
	exportsDownloadList,
	exportsPersonnelTimeRecord,
	exportsProjectRDPersonsList
} from "./project";
import { commonFileGetFileByUrl } from "@/api/ChinaHigh";
export default {
	data() {
		return {
			tableData: [],
			loading: true,
			total: 1,
			projectId: "",
			yearList: [],
			queryParams: {},
			fileType: [
				"项目计划任务书",
				"项目立项决议书",
				"项目研发人员名单",
				"人员工时记录",
				"用于研发活动的仪器设备,无形资产的费用分配表",
				"成果物附件",
				"验收附件",
				"科技行政主管出具的鉴定意见"
			],
			upload: {
				// 是否禁用上传
				isUploading: false,
				// 上传的地址
				url: this.mainBaseURL + "/exports/upload"
			}
		};
	},
	created() {
		this.queryParams.projectId = sessionStorage.getItem("zt_jjkc_project_id");
		this.init();
	},
	methods: {
		tableRowClassName({ row, rowIndex }) {
			if ((rowIndex + 1) % 2 === 0) {
				return "background:#fff";
			} else {
				return "background:#F5F7FA";
			}
		},
		init() {
			exportsQueryAdditionalDeductionReferenceMaterialsAnnual(
				this.queryParams.projectId
			).then(res => {
				this.yearList = res.data;
				this.queryParams.annual = res.data[0];
				this.getList();
			});
		},
		buttonType(val) {
			if (val == this.queryParams.annual) {
				return "primary";
			} else {
				return "info";
			}
		},
		step(val) {
			this.queryParams.annual = val;
			this.getList();
		},
		getList() {
			this.loading = true;
			exportsQueryAdditionalDeductionReferenceMaterials(this.queryParams).then(
				res => {
					if (res.code == "00000") {
						this.tableData = res.data;
					}
					this.loading = false;
				}
			);
		},
		downloads() {
			exportsDownloadList(this.queryParams).then(res => {
				if (res.data !== null) {
					window.open(res.data.fileUrl, "_blank");
				}
				this.getList();
			});
		},
		sc(type) {
			if (type == 3) {
				exportsProjectRDPersonsList(this.queryParams).then(res => {
					if (res.code == "00000") {
						this.msgSuccess("生成成功");
						this.getList();
					}
				});
			}

			if (type == 4) {
				exportsPersonnelTimeRecord(this.queryParams).then(res => {
					if (res.code == "00000") {
						this.msgSuccess("生成成功");
						this.getList();
					}
				});
			}
		},
		xz(url) {
			commonFileGetFileByUrl({ url: url }).then(res => {
				if ((res.code = "00000")) {
					window.open(res.data);
				}
			});
		},
		handleFileSuccess(response, file, fileList) {
			this.loading = false;
			if (response.code == "00000") {
				this.msgSuccess("上传成功");
				this.getList();
			} else {
				this.upload.isUploading = false;
				this.$message.error(response.msg);
			}
		},
		handleFileError(response, file, fileList) {
			this.loading = false;
		},
		beforeUpload() {
			console.log("before");
			// this.loading = true;
		},
		Exceed() {
			this.$message.error("每项只能上传一次,重新上传请刷新页面");
		}
	}
};
</script>
<style scoped>
.txt {
	font-size: 13px;
	color: #666;
}
.title_box {
	width: 100%;
	height: 40px;
	background-color: #e6f7ff;
	box-shadow: rgba(186, 231, 255, 1) solid 1px;
	border-radius: 4px;
	font-size: 13px;
	line-height: 40px;
	padding: 0 20px;
	box-sizing: border-box;
	margin: 20px 0;
}
.form_box .el-form-item {
	width: 46%;
}
.text {
	font-size: 14px;
	padding: 10px 20px;
	position: relative;
	border-bottom: 1px solid #dbdbdb;
	margin-bottom: 20px;
}
.text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 10px;
	background: #7c99fd;
}
.gsadd {
	position: absolute;
	left: 17px;
	top: 20px;
	z-index: 9;
}
.upload-demo {
	float: left;
}
</style>
